
import { ThemedText, ThemedView } from "@app/theme";
import { Image } from "react-native";
const INFO_1 ="https://volt-images-alpha.s3.ap-south-1.amazonaws.com/eligible_credit_limit.png"
const INFO_2 = "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/withdraw_cash.png"
const INFO_3 = "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/verify_interest_charges.png"
const HowItWorks = ()=> {
    return(
        <ThemedView p="lg" backgroundColor="bg-fill-primary">
            <ThemedText variant="b2s" color="text-primary" mb="lg">
            Unlock more limit in just 3 steps
            </ThemedText>
            <ThemedView mb="2xl" flexDirection="row" alignItems="center">
                <Image source={{uri:INFO_1}} style={{width:40,height:40}} />
                <ThemedView ml="md">
                    <ThemedText variant="b3m" color="text-primary">Check eligible credit limit</ThemedText>
                    <ThemedText variant="b4r" color="text-secondary">It only takes 15 seconds</ThemedText>
                </ThemedView>
            </ThemedView>
            <ThemedView mb="2xl" flexDirection="row" alignItems="center">
                <Image source={{uri:INFO_3}} style={{width:40,height:40}} />
                <ThemedView flex={1} ml="md">
                    <ThemedText variant="b3m" color="text-primary">Verify interest & charges</ThemedText>
                    <ThemedText variant="b4r" color="text-secondary">Confirm interest rate, processing fee, & any charges that may be applicable</ThemedText>
                </ThemedView>
            </ThemedView>
            <ThemedView mb="2xl" flexDirection="row" alignItems="center">
                <Image source={{uri:INFO_2}} style={{width:40,height:40}} />
                <ThemedView ml="md">
                    <ThemedText variant="b3m" color="text-primary">Finish application & withdraw cash</ThemedText>
                    <ThemedText variant="b4r" color="text-secondary">Get cash in your account within 2 business hours </ThemedText>
                </ThemedView>
            </ThemedView>
        </ThemedView>
    )
}
export default HowItWorks